import script from "./_ReportAppendixSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./_ReportAppendixSingle.vue?vue&type=script&setup=true&lang=js"

import "./_ReportAppendixSingle.vue?vue&type=style&index=0&id=36f6a556&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f6a556"]])

export default __exports__